import React from 'react'

export function TitleBarTitleText({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return (
    <h1 className={'font-demibold text-headline-2 text-center'}>{children}</h1>
  )
}
